<template>
  <router-link tag="li" class="nav-item nav-dropdown" :to="url" disabled>
    <div :class="`nav-link ${catalogerUser ? '' : 'nav-dropdown-toggle'}`" @click="handleClick"><i :class="icon"></i> {{name}}</div>
    <ul class="nav-dropdown-items">
      <slot></slot>
    </ul>
  </router-link>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      catalogerUser: this.$store.getters.signedRoles.includes('CATALOGER_USER')
    }
  },
  methods: {
    handleClick (e) {
      e.preventDefault()

      if (!this.catalogerUser) {
        e.target.parentElement.classList.toggle('open')
      }
    }
  }
}
</script>
